import FederationTemplateConfig from "../template";
import { merge } from "lodash-es";
import Colors, { quillColors } from "./colors";
export default class UkrainianFederation extends FederationTemplateConfig {
    constructor() {
        super();
        this.logo = {
            image: require("./logo.svg"),
            label: "ВФКС",
            backgroundColor: "accent"
        };
        this.countryCode = "UA";
        this.locale = "uk-UA";
        this.sprites = require("./ukraine-sprites.svg");
        this.placeholderLogo = require("./placeholder-logo.png");
        this.webTitle = "ВФКС";
        this.colors = merge(this.colors, Colors);
        this.quillColors = merge(this.quillColors, quillColors);
        this.heroBanner = merge(this.heroBanner, {
            webp: require(`./banner.webp`),
            jpeg: require(`./banner.jpg`)
        });
        this.documents = {
            paymentTermsOfService: null
        };
        this.links = {
            homepage: null,
            news: null,
            rulesPage: null
        };
    }
}
